import React, { Component } from "react";
import AppDynamicFilterModal from "../../partials/AppDynamicFilterModal";
export class BankDumpsSearch extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.state = {
      openDrawer: false,
    };
    this.fields = [
      {
        name: "bankName",
        label: "Bank Name",
        type: "select",
        options: [],
      },
      {
        name: "applicationLeadId",
        label: "Application No.",
        type: "text",
      },
      // {
      //   name: "productType",
      //   label: "Product Type",
      //   type: "select",
      //   options: [],
      // },
      {
        name: "designation",
        label: "Month & Year",
        type: "month",
      },
    ];
  }

  componentDidMount() {
    // this.getProductTypes();
    this.getBankNames();
  }

  getProductTypes() {
    this.props.apis.apiGetProductTypes().then((res) => {
      console.log({ res });

      let productType = this.fields.find((o) => o.name == "productType");
      productType.options = res;
    });
  }

  getBankNames() {
    let payload = {
      page: 1,
    };
    this.props.apis.apiGetBanknames(payload).then((data) => {
      let bankNameField = this.fields.find((o) => o.name === "bankName");
      bankNameField.options = data;
    });
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { openDrawer } = this.state;
    return (
      <div className="d-flex align-items-center justify-content-end">
        <button
          type="button"
          className="btn filter_modal_btn"
          onClick={(...args) => this.toggleDrawer(...args)}
        >
          <i class="fa-solid fa-filter me-2"></i>
          <span>Filters</span>
        </button>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={this.fields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(BankDumpsSearch);
